
import { IGeofenceNavigationPoint } from "@directives/_map/geofences/geofences.interfaces";
import { IExternalReference } from "@directives/_veri/externalReference/externalReferences.interfaces";
import { IGeoArea } from "../main/modules/tms/_models/IGeoArea";
import { ITag } from "./ITag";

export interface IGeocodedAddress {
    Id?: number;
    FormattedAddress?: string;
    PostCode?: string;
    PlaceId?: number;
    BoundsPoints?: { Latitude: number, Longitude: number }[];

    CenterPoint: {
        Latitude?: number;
        Longitude?: number;
    };

    UtcUpdated?: string;
}

export enum Colour {
    None,
    Blue,
    Red,
    Yellow,
    Orange,
    Green,
    Purple,
    Black,
    Grey
}

export enum GeofenceCategory {
    Standard = 0,
    Zone = 1
}

// Todo: Move to App.Interfaces
export interface IGeofence extends IGeoArea {
    Addr1?: string;
    Addr2?: string;
    Addr3?: string;
    Addr4?: string;

    Description?: string;
    DescriptionExt?: string;

    Email?: string;
    ContactEmail?: string;
    Phone?: string;
    Notes?: string;
    DeliveryInformation?: string;
    AdditionalInformation?: string; 
    
    Category?: GeofenceCategory;

    Id?: number;
    AccountId?: number;

    RouteStopIsActive?: boolean;
    RouteStopIsDepot?: boolean;

    Tags?: ITag[];
    TagIds?: number[];
    PriorityTag?: ITag;

    Created?: string;
    Updated?: string;
    Restricted?: boolean;

/* Our properties */
    HideFromMap?: boolean;
    PendingDelete?: boolean;
    externalReferences?: IExternalReference[];

    //----

    navigationPoints?: IGeofenceNavigationPoint[];
    isSystemGeofence?: boolean;
    isRestrictedReadOnly?: boolean;
    isReadOnly?: boolean;
}
